.slider{width:1024px;transform:translate(.8rem)}.number-line{width:896px;margin:0 auto;display:block}
/*# sourceMappingURL=chain-20.component-W2HKFMRP.css.map */
